module.exports = __webpack_public_path__ + "img/main-logo.709de6da.png";